import { CRON_STATUS_LABELS } from "./cronSchedule";

const TONES = {
    COMPLETED: ["bg-[#ecfdf5] text-[#065f46]", "bg-[#10b981]"],
    WARNING: ["bg-[#fff7ed] text-[#c2410c]", "bg-[#fb923c]"],
    ERROR: ["bg-[#fef2f2] text-[#b91c1c]", "bg-[#ef4444]"],
    IN_PROGRESS: ["bg-[#eff6ff] text-[#1d4ed8]", "bg-[#3b82f6] animate-pulse"],
    PAUSED: ["bg-[#f3f4f6] text-[#6b7280]", "bg-[#9ca3af]"],
    NEVER: ["bg-white text-[#6b7280] ring-1 ring-inset ring-[#ececef]", "ring-[1.5px] ring-inset ring-[#9ca3af]"],
    UNKNOWN: ["bg-white text-[#6b7280] ring-1 ring-inset ring-[#ececef]", "ring-[1.5px] ring-inset ring-[#9ca3af]"],
};

const CronStatusPill = ({ status, label, suffix }) => {
    const [chip, dot] = TONES[status] || TONES.UNKNOWN;
    return (
        <span className={`inline-flex h-[22px] items-center gap-1.5 whitespace-nowrap rounded px-2 text-[11.5px] font-medium tracking-[.01em] ${chip}`}>
            <i aria-hidden="true" className={`h-1.5 w-1.5 flex-none rounded-full ${dot}`} />
            {label || CRON_STATUS_LABELS[status] || CRON_STATUS_LABELS.UNKNOWN}
            {suffix}
        </span>
    );
};

export default CronStatusPill;
